import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import Select from 'react-select';

import GenericListPair from 'modules/common/components/GenericListPair';

import { connect } from 'react-redux';
import { ModalContext } from 'App';
import { customStyle } from 'helper';

import PropTypes from 'prop-types';
import useDebounce from 'modules/common/components/UseDebounce';
import BarangayContent from './BarangayContent';
import * as actions from '../action';
import * as c from '../constant';

const form = {
  keyword: '',
};

function BarangayContainer({
  match,
  isLoading,
  history,
  getBarangays,
  barangayList,
  barangayListPager,
  getRegionsList,
  getProvinceList,
  getMunicipalityList,
  regionsList,
  municipalityList,
  provinceList,
}) {
  const [region, setRegion] = useState({
    label: '',
    value: 0,
  });

  const [province, setProvince] = useState({
    label: '',
    value: 0,
  });

  const [municipality, setMunicipality] = useState({
    label: '',
    value: 0,
  });

  const handleRegionSelect = (e) => {
    setRegion(e);
    getProvinceList({ region_code: e.value, isPaginate: 1 });
    setProvince('');
    setMunicipality('');
  };

  const handleProvinceSelect = (e) => {
    setProvince(e);
    getMunicipalityList({ province_code: e.value, isPaginate: 1 });
    setMunicipality('');
  };

  const handleMunicipalitySelect = (e) => {
    setMunicipality(e);
    getBarangays({ municipality_code: e.value });
  };

  const [formData, setFormData] = useState(form);

  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const createDropdown = (list) => {
    const newList = [];
    list.map((data) => {
      return newList.push({
        label: data.attributes.name,
        value: data.attributes.code,
      });
    });
    return newList;
  };

  useEffect(() => {
    getBarangays();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  useEffect(() => {
    getRegionsList({ isPaginate: 1 });

    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    name: formData.keyword,
    sort_by: 'asc',
    municipality_code: municipality.value,
  };

  useEffect(() => {
    if (debouncedSearchTerm) {
      getBarangays({
        name: formData.keyword,
        municipality_code: municipality.value,
      });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);
  return (
    <div>
      <div className="card p-0 mb-3 mt-3">
        <div className="container-fluid d-flex px-0">
          <div className="d-inline w-auto d-flex justify-content-start m-3">
            <label className="label-transaction-card mb-0 d-flex align-items-center mr-3">
              Select Region:
            </label>
            <div style={{ width: 250 }}>
              <Select
                styles={customStyle}
                placeholder="Select Region"
                value={region}
                options={createDropdown(regionsList)}
                onChange={(e) => {
                  handleRegionSelect(e);
                }}
              />
            </div>
          </div>
          <div className="d-inline w-auto d-flex justify-content-start m-3">
            <label className="label-transaction-card mb-0 d-flex align-items-center mr-3">
              Select Province:
            </label>
            <div style={{ width: 250 }}>
              <Select
                value={province}
                styles={customStyle}
                placeholder="Select Province"
                options={createDropdown(provinceList)}
                onChange={(e) => {
                  handleProvinceSelect(e);
                }}
              />
            </div>
          </div>
          <div className="d-inline w-auto d-flex justify-content-start m-3">
            <label className="label-transaction-card mb-0 d-flex align-items-center mr-3">
              Select Municipality:
            </label>
            <div style={{ width: 250 }}>
              <Select
                options={createDropdown(municipalityList)}
                styles={customStyle}
                placeholder="Select Municipality"
                value={municipality}
                onChange={(e) => {
                  handleMunicipalitySelect(e);
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <Route
        path={`${match.path}/:barangayId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Barangay List"
            getData={getBarangays}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search Barangay..."
            pathName={`${match.path}/:barangayId?`}
            listName="Barangay"
            label="Barangay"
            renderItem={(item) => (
              <div className="p-3">
                <div className="transaction-list-company">
                  {_.get(item, 'attributes.name')}
                </div>
              </div>
            )}
            isLoading={isLoading}
            selected={params.barangayId}
            data={barangayList}
            dataPager={barangayListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:barangayId?`}
                    render={() => (
                      <BarangayContent />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:barangayId?`}
                  render={() =>
                    !params.barangayId && barangayList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(barangayList, '0.id')}`}
                      />
                    ) : (
                      <Redirect
                        to={`${match.url}/${_.get(barangayList, '0.id')}`}
                      />
                    )
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

BarangayContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getBarangays: PropTypes.instanceOf(Function).isRequired,
  barangayList: PropTypes.instanceOf(Array).isRequired,
  barangayListPager: PropTypes.instanceOf(Object).isRequired,
  getRegionsList: PropTypes.instanceOf(Function).isRequired,
  getProvinceList: PropTypes.instanceOf(Function).isRequired,
  getMunicipalityList: PropTypes.instanceOf(Function).isRequired,
  regionsList: PropTypes.instanceOf(Array).isRequired,
  provinceList: PropTypes.instanceOf(Array).isRequired,
  municipalityList: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  isLoading: api.loading.indexOf(c.GET_BARANGAYS) > -1,
  barangayList: _.get(api, `${c.GET_BARANGAYS}.list`) || [],
  barangayListPager: _.get(api, `${c.GET_BARANGAYS}.pager`) || {},
  regionsList: _.get(api, `${c.GET_REGION}.list`) || [],
  provinceList: _.get(api, `${c.GET_PROVINCE}.list`) || [],
  municipalityList: _.get(api, `${c.GET_MUNICIPALITIES}.list`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BarangayContainer);
